import type { ReactNode } from 'react';

export const symbol_share_windows: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M308.5-378.63Q300-387.25 300-400v-210q0-24.75 17.63-42.38Q335.25-670 360-670h350l-92-92q-9-9-8.5-21t9.34-21q8.84-9 21-9t21.16 9l143 143q9 9 9 21t-9 21L661-475q-9 9-21 9t-21.12-9.05q-9.12-9.06-9.5-21.5Q609-509 618-518l92-92H360v210q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM180-120q-24.75 0-42.37-17.63Q120-155.25 120-180v-610q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v610h520v-160q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v160q0 24.75-17.62 42.37Q724.75-120 700-120H180Z"
		/>
	</svg>
);
